export default "__VITE_ASSET__dcf0e54f__"